import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty, isNil, isString } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class TranslateWrapperService extends TranslateService {
  public instant(key: string, interpolateParams?: object): string {
    // Custom logic for translation can be added here
    let translatedStr = key;

    if (isNil(key) || !isString(key)) {
      return key;
    }

    try {
      translatedStr =
        isEmpty(key) || !key.length
          ? key
          : super.instant(key, interpolateParams);
    } catch (error) {
      console.error('Translation error: ', error);

      // return original key if translation fails
      return translatedStr;
    }

    return translatedStr;
  }
}
